export default "__VITE_ASSET__C1OTHI0x__"